<template>
  <li class="update" v-if="changelog.app_changelog">
    <ul class="log-list">
      <li class="log-item clearfix" v-for="(item, index) in changelog.app_changelog" :key="index">
        <div class="time">
          {{item.update_time}}
        </div>
        <div class="detail">
          <dl class="log">
            <dt>更新 {{item.update_version}}</dt>
            <pre>{{item.update_content | formatHtml}}</pre>
          </dl>
        </div>
      </li>
    </ul>
    <div @click="loadMore" class="load-more" v-if="page.curPage!=page.totalPage">
      加载更多
    </div>
  </li>
</template>

<script type="text/javascript">
  let qs = require("qs");
  export default {
    filters: {
      formatHtml(data) {
         data = data.replace(/&lt;/ig, '<');
         data = data.replace(/&gt;/ig, '>');
         data = data.replace(/&nbsp;/ig, ' ');
         data = data.replace(/&quot;/ig, '"');
         data = data.replace(/&#39;/ig, "'");
         return data;
      }
    },
    data() {
      return {
        changelog: {},
        page: {}
      }
    },
    methods: {
      getUpdateList(page) {
        axios.post(myUrl + "core/product/detail/"+this.$route.params.aid+"/", qs.stringify({
          aspect:'changelog',
          page: page
        })).then((res) => {
          res = res.data;
          if (res.result) {
            this.changelog = res.data;
            this.page = res.data.page;
          }else {
            console.log(res.message);
          }
        })
      },
      loadMore() {
        if (this.page.curPage<this.page.totalPage) {
          this.page.curPage++;
          this.getUpdateList(this.page.curPage);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.getUpdateList(1);  // 获取更新记录  默认加载第一页
      })
    }
  }
</script>

<style media="screen">
  pre{
    white-space: pre-wrap;
    white-space: -moz-pre-wrap;
    white-space: -pre-wrap;
    white-space: -o-pre-wrap;
  }
</style>



// WEBPACK FOOTER //
// update.vue?08852c34